<template>
    <select class="form-control" v-model="selected">
        <option disabled value="placeholder">{{ $t('common.placeholders.selectOption') }}</option>
        <option v-for="country in countries" v-bind:value="country.name" :key="country.alpha3Code">{{ getLocalizedName(country) }}</option>
    </select>
</template>

<script>
/**
This component used to use an external service, but when that failed the system was reverted to using a static file bundled with the frontend. 

The file is bundled in @/src/assets

This is obtained by running: 
curl https://restcountries.com/v3/all | jq -c '[ .[] | {
    name: .name.common,
    alpha2Code: .cca2,
    alpha3Code: .cca3,
    translations: {
        "de": .translations.deu.common,
        "fr": .translations.fra.common,
        "it": .translations.ita.common,
        "en": .name.common
    }
}] | sort_by(.name)' > countries.json

This will produce a flat JSON with all the records from the entire world. If you only want europe, change the 
URL to https://restcountries.com/v3/region/europe

Docs here: https://restcountries.com/
*/

import CountriesList from "@/assets/countries.json";
export default {
    name: "CountryDropdown",
    props: {
        value: {
            type: String,
            required: true,
            default: undefined
        }
    },
    methods: {
        findByAlpha2Code: function(countries, code) {
            return countries.find(el => el.alpha2Code === code);
        },
        getLocalizedName: function(country) {
            if (country.translations === undefined) {
                return country.name;
            }

            let locale = this.$i18n.locale;
            let value = country.translations[locale];
            return value === undefined ? country.name : value;
        }
    },
    computed: {
        selected: {
            get() {
                return this.value;
            }, set(val) {
                let comp = val === this.placeholder ? undefined : val;
                this.$emit('input', comp);    
            }
        }
    },
    mounted() {
        let elems = this.unsortedCountries;

        // These are countries that need to appear at the top. before the others
        let countries = ["CH", "DE", "AT", "LI", "NL", "IT", "FR", "US"].map(el => this.findByAlpha2Code(elems, el));
        this.countries = countries.concat(elems.filter((item) => countries.indexOf(item) < 0)).filter(el => el !== undefined);
        
        // Select switzerland as the default country
        this.selected = this.countries.find(el => el.alpha2Code === "CH").name;
    },
    created()  {
        this.selected = this.placeholder;
    },
    data() {
        return {
            placeholder: "placeholder",
            countries: undefined,
            unsortedCountries: CountriesList
        }
    }
}
</script>